import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, TextField, Button, Typography } from '@mui/material';
import './ResetPassword.css';
import logo from './assets/Logo.png';

function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const { postalCode, phone } = location.state || {};
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleReset = async () => {
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    try {
      const response = await fetch("https://carcure.ca/backend/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ postalCode, phone, newPassword })
      });
      const data = await response.json();
      if (response.ok) {
        setMessage("Your password has been successfully updated.");
      } else {
        setError(data.message || "Error updating password.");
      }
    } catch (err) {
      setError("Server error. Please try again later.");
    }
  };

  return (
    <div className="reset-content-container">
      <div className="top-text-box">
        <Typography variant="h4" className="top-title">Reset Password</Typography>
      </div>
      <div className="form-container">
        <div className="modal-header">
          <img src={logo} alt="Logo" className="modal-logo" />
          <button className="close-button" onClick={() => navigate("/login")}>×</button>
        </div>
        {message ? (
          <>
            <Typography variant="h5" align="center">{message}</Typography>
            <Button 
              variant="contained" 
              color="primary" 
              fullWidth 
              onClick={() => navigate("/login")}
              className="custom-button"
              style={{ marginTop: '20px' }}
            >
              Close
            </Button>
          </>
        ) : (
          <>
            {error && (
              <Typography color="error" align="center" style={{ marginBottom: '10px' }}>
                {error}
              </Typography>
            )}
            <TextField 
              fullWidth 
              label="New Password" 
              type="password"
              value={newPassword} 
              onChange={(e) => setNewPassword(e.target.value)}
              margin="normal"
              className="custom-input"
            />
            <TextField 
              fullWidth 
              label="Confirm New Password" 
              type="password"
              value={confirmPassword} 
              onChange={(e) => setConfirmPassword(e.target.value)}
              margin="normal"
              className="custom-input"
            />
            <Button 
              variant="contained" 
              color="primary" 
              fullWidth 
              onClick={handleReset}
              className="custom-button"
              style={{ marginTop: '20px' }}
            >
              Update Password
            </Button>
          </>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
